module.exports = __webpack_public_path__ + "img/section_l.36acd970.png";